/**
 * Copyright (c) 2024 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { zIndex as consumerComponentsZIndex } from '@blend/consumer-components';
import { assign } from 'lodash';
export const zIndex = assign(consumerComponentsZIndex, {
  notification: 2000,
  popover: 1010,
  headerDropdownIcon: 100,
  headerDropdownItem: 100,
  headerDropdown: 50,
  headerControl: 50,
  documentModal: 46,
  reviewBar: 45,
  sidebar: 10,
  // bottomSheet > contentOverlay so that clicking outside the bottom sheet component
  // collapses it, but clicking on it does not
  bottomSheet: 40,
  contentOverlay: 20,
  header: 15,
  mobileDocSubheader: 10,
  mobileParticipantStrip: 20
});